import { call, put, select } from "redux-saga/effects";
import { setSource } from "services/Source/actions";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { getSourceRequest } from "./api";
import { sourceSelector } from "./selectors";

const sourcesSchema = new schema.Entity("sources" , {},{ idAttribute: "code" });
const sourcesListSchema = new schema.Array(sourcesSchema);

export function* getSourceWorker() {
    try {
        const { codes } = yield select(sourceSelector);
        if(!codes.length){
            yield put(setSource({ isLoadingSource: true }));
            const { sources } = yield call(getSourceRequest);
            const { result, entities } = normalize(sources, sourcesListSchema);
            yield put(setSource({
                isLoadingSource: false,
                sources: entities.sources,
                codes: result
            }));
        }
    } catch (error) {
        yield put(setSource({ isLoadingSource: false }));
        showError(error);
    }
}

export function* getSource() {
    yield call(getSourceWorker);
}
